import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useTrail, animated } from 'react-spring';
import { useBusinessCard } from './BusinessCard';
import firebase from 'firebase/app';
import 'firebase/storage';
import styled from 'styled-components';
import { Dialog } from '@reach/dialog';
import '@reach/dialog/styles.css';
import PurchaseButtons from './PurchaseButtons';
import { Box } from '@material-ui/core';
import { ArrowLeftIcon } from '@material-ui/pickers/_shared/icons/ArrowLeftIcon';
import { ArrowRightAltSharp, ArrowRightOutlined, ArrowRightSharp } from '@material-ui/icons';
import { ArrowRightIcon } from '@material-ui/pickers/_shared/icons/ArrowRightIcon';
import EllipsisText from 'react-ellipsis-text';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './ProductsList3.css';

const wai = '/images/social/wai-message2.png';

const Container = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  width: ${(p) => p.theme.dimensions.width}px;
`;
const config = { mass: 10, tension: 2000, friction: 200 };

export async function getProductImage(image) {
  if (typeof image === 'string') {
    return await firebase.storage().ref(image).getDownloadURL();
  }
  if (image && typeof image === 'object') {
    return URL.createObjectURL(image);
  }
  return null;
}

const SecondaryProductsContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: row;
  margin-top: 1rem;
  grid-template-columns: 0.6fr 0.2fr;
  column-gap: 1rem;
  align-content: center;
  justify-content: center;
  justify-items: stretch;
`;

const GridContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

const ButtonsContainer = styled.div`
  flex-direction: row;
  flex: 6;
  display: flex;
  align-items: center;
  padding: 0.2em 1em;
`;

const DetailsContainer = styled.div`
  flex-direction: row;
  flex: 6;
  display: flex;
  padding: 1em;
`;

const ArrowRight = styled(ArrowRightIcon)`
  fill: ${(p) => p.theme.textColor};
  width: 1.6em;
  height: 1.6em;
  align-self: center;
  display: flex;
`;

const ArrowLeft = styled(ArrowLeftIcon)`
  fill: ${(p) => p.theme.textColor};
  width: 1.6em;
  align-self: center;
  height: 1.6em;
  display: flex;
`;

const ProductsList3 = ({onPurchase, addToCart}) => {
  const [ready, setReady] = useState(false);
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const toggle = () => {
    if (open) {
      setFirstImage(modalProduct?.image);
      setSecondImage(modalProduct?.image2);
      setThirdImage(modalProduct?.image3);
    }
    setOpen(!open);
  };
  const [modalProduct, setModalProduct] = useState(null);
  const [productsWithImages, setProductsWithImages] = useState([]);

  const [firstImage, setFirstImage] = useState();
  const [secondImage, setSecondImage] = useState();
  const [thirdImage, setThirdImage] = useState();

  const instance = useBusinessCard();
  const {
    user,
    card: { products, backgroundColor, phoneNumber, waText = 'האם קיים במלאי המוצר: ' },
  } = instance;

  const sharePhoneNumber = '972' + phoneNumber?.slice(1);

  const { MAX_PRODUCTS } = useMemo(() => {
    const isPremium =
      user.plan === 'pro' || ['', 'business'].includes(user.role);
    return { MAX_PRODUCTS: isPremium ? 50 : 25, isPremium };
  }, [user.plan, user.role]);

  const _products = useMemo(() => {
    return !user.plan || !products
      ? undefined
      : products.slice(0, MAX_PRODUCTS);
  }, [products, user, MAX_PRODUCTS]);

  const fetchProductsImages = useCallback(async () => {
    if (!_products) {
      return [];
    }
    const promises = _products
      .filter((item) => !!item.image)
      .map(async (item) => {
        const image = await getProductImage(item.image);
        let image2 = null;
        let image3 = null;
        if (item.image2) {
          image2 = await getProductImage(item.image2);
        }
        if (item.image3) {
          image3 = await getProductImage(item.image3);
        }
        return { ...item, image, image2, image3 };
      });
    const res = await Promise.all(promises);
    return res;
  }, [_products]);

  useEffect(() => {
    fetchProductsImages().then((res) => {
      setProductsWithImages(res);
      setTimeout(() => {
        setReady(true);
      }, 500);
    });
  }, [setProductsWithImages, fetchProductsImages]);

  const [trail, set] = useTrail(productsWithImages.length, () => ({
    config,
    opacity: 0,
    from: { opacity: 0, x: 0, height: 0 },
  }));

  useEffect(() => {
    setFirstImage(modalProduct?.image);
    setSecondImage(modalProduct?.image2);
    setThirdImage(modalProduct?.image3);
  }, [modalProduct]);

  useEffect(() => {
    if (ready) {
      set({ opacity: 1 });
    }
  }, [set, ready]);

  if (!products?.length) {
    return null;
  }

  const item = productsWithImages[currentIndex] ?? products[currentIndex];

  const shareTextForProduct = (product) => `${waText} ${product?.title}`;
  // const shareTextForProduct = (product) => `
  // רוצה לרכוש את המוצר: ${product?.title}
  // האם קיים במלאי?
  // תודה`;

  return (
    // <TransitionGroup>
    //   <CSSTransition key={currentIndex} in={item !== undefined} timeout={1000} unmountOnExit classNames="messageout">
        <>
          <Container>
            <GridContainer>
              {currentIndex < products.length - 1 ?
                <div style={{ display: 'flex' }}><ArrowRight onClick={() => setCurrentIndex(currentIndex + 1)} />
                </div> :
                <div style={{ display: 'flex', width: 60, height: 60 }} />}
              <div style={{ flex: 1, display: 'flex' }} key={item.title}>
                <ProductContainer onClick={() => {
                  setModalProduct(item);
                  toggle();
                }}>
                  <ProductImgContainer>
                    <ProductImg src={item.image} alt={`${item.title} - ${item.description}`} />
                  </ProductImgContainer>
                </ProductContainer>
              </div>
              {currentIndex > 0 ?
                <div style={{ display: 'flex' }}><ArrowLeft onClick={() => setCurrentIndex(currentIndex - 1)} /></div> :
                <div style={{ display: 'flex', width: 60, height: 60 }} />}
            </GridContainer>

            <DetailsContainer>
              <div style={{ flexDirection: 'column', alignItems: 'flex-start', flex: 4, display: 'flex' }}>
                <ProductTitle>{`שם המוצר: ${item.title}`}</ProductTitle>
                {item.description && item.description.length > 0 && <ProductDescription text={item.description} length={'80'} />}
              </div>
              <div style={{ flexDirection: 'column', paddingRight: 10, flex: 2, display: 'flex' }}>
                <div style={{ flexDirection: 'row', flex: 2, display: 'flex' }}>
                  {item.image2 ? <ProductImgContainerSmall><ProductImg src={item.image2}
                                                                       alt={`${item.title} - ${item.description}`} /></ProductImgContainerSmall> :
                    <div style={{ flex: 1, display: 'flex' }} />}
                  {item.image3 ? <ProductImgContainerSmall><ProductImg src={item.image3}
                                                                       alt={`${item.title} - ${item.description}`} /></ProductImgContainerSmall> :
                    <div style={{ flex: 1, display: 'flex' }} />}
                </div>
                {item.price && <ProductPrice>{item.price}</ProductPrice>}
              </div>
            </DetailsContainer>
            <ButtonsContainer>
              <div style={{ display: 'flex', flex: 4, justifyContent: 'flex-end' }}>
                <PurchaseButtons withWhatsapp={false} item={item} size={7} onPurchase={onPurchase} />
              </div>
              <Badge
                href={`https://wa.me/${sharePhoneNumber}?text=${shareTextForProduct(
                  item,
                )}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                <BadgeImage src={wai} />
              </Badge>
            </ButtonsContainer>
          </Container>
          <StyledDialog isOpen={open} onDismiss={toggle}>
            <LighboxContainer>
              <LightboxHeader onClick={toggle}> חזרה לקטלוג </LightboxHeader>
              <LightboxImage
                shareText={shareTextForProduct(modalProduct)}
                src={firstImage}
                title={modalProduct?.title}
                phoneNumber={sharePhoneNumber}
              />
              {secondImage && <SecondaryProductsContainer>
                <LightboxSmallImage
                  shareText={shareTextForProduct(modalProduct)}
                  src={secondImage}
                  title={modalProduct?.title}
                  phoneNumber={sharePhoneNumber}
                  onClick={() => {
                    setSecondImage(firstImage);
                    setFirstImage(secondImage);
                  }}
                />
                {thirdImage &&
                <LightboxSmallImage
                  shareText={shareTextForProduct(modalProduct)}
                  src={thirdImage}
                  title={modalProduct?.title}
                  phoneNumber={sharePhoneNumber}
                  onClick={() => {
                    setThirdImage(firstImage);
                    setFirstImage(thirdImage);
                  }}
                />}
              </SecondaryProductsContainer>}
              {modalProduct?.description && <LightboxDescription>
                פירוט המוצר: {modalProduct?.description}
              </LightboxDescription>}
              <div style={{display: 'flex',justifyContent:'center'}}>
                  {modalProduct?.price && <LightboxPrice>{modalProduct?.price}</LightboxPrice>}
                  {modalProduct?.price && <LightboxCart onClick={() =>{
                                  addToCart(modalProduct)
                                  toggle()
                                  window.scrollTo(0, 0);

                  }}>הוסף לסל</LightboxCart>}
              </div>
              {/* {modalProduct?.price && <LightboxPrice>{modalProduct?.price}</LightboxPrice>} */}
            </LighboxContainer>
          </StyledDialog>
        </>
    //   </CSSTransition>
    // </TransitionGroup>
  );
};

const StyledDialog = styled(Dialog)`
  width: ${(p) => p.theme.dimensions.vw(90)}px;
  max-height: ${(p) => p.theme.dimensions.vh(90)}px;
  padding: 0.2rem;
  overflow-y: scroll;
`;
const LighboxContainer = styled.div`
  display: grid;
  grid-template-rows: 5rem 3fr fit-content auto;
  font-family: ${(p) => p.theme.font};
`;
const LightboxHeader = styled.span`
  cursor: pointer;
  grid-row: 1;
  padding: 0rem 1.75rem;
  height: 2rem;
`;
const LightboxDescription = styled.p`
  width: ${(p) => p.theme.dimensions.vw(75)}px;
  justify-self: center;
  margin: 0.5rem 0px;
`;
const LightboxPrice = styled.div`
  background-color: #111111;
  margin: 0.5rem;
  color: #f1f1f1;
  align-self: center;
  justify-self: center;
  padding: 1rem 3rem;
`;

const LightboxCart = styled.div`
  background-color: #111111;
  margin: 0.5rem;
  color: #f1f1f1;
  align-self: center;
  justify-self: center;
  padding: 1rem 3rem;
  cursor: pointer;
`;

const LightboxImage = ({ src, phoneNumber, title, shareText }) => {
  return (
    <LBImageContainer>
      <a
        href={`https://wa.me/${phoneNumber}?text=${shareText}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <LBWAI src="/images/social/wai.png" />
      </a>

      <LBContact
        href={`https://wa.me/${phoneNumber}?text=${shareText}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        שלחו לי שאלה בוואצפ
      </LBContact>
      <LBImage src={src} />
      <LBTitle>{title}</LBTitle>
    </LBImageContainer>
  );
};

const LightboxSmallImage = ({ src, phoneNumber, title, shareText, onClick }) => {
  return (
    <LBSmallImageContainer onClick={onClick}>
      <LBSmallImage src={src} />
      <LBTitle>{title}</LBTitle>
    </LBSmallImageContainer>
  );
};

const LBImageContainer = styled.div`
  align-self: center;
  justify-self: center;
  border: 2px solid #111111;
  padding: 0rem 0.5rem 0.5rem 0.5rem;
  display: grid;
  width: 75vw;
  grid-template-rows: 3rem auto 1rem;
  position: relative;
`;

const LBSmallImageContainer = styled.div`
  align-self: center;
  justify-self: center;
  border: 2px solid #111111;
  padding: 0rem 0.5rem 0.5rem 0.5rem;
  margin: 0rem 0.2rem 0.5rem 0.2rem;
  display: grid;
  width: 36vw;
  grid-template-rows: 1rem auto 1rem;
  position: relative;
`;

const Icon = styled.img`
  width: ${(p) => p.theme.dimensions.vw(4)}px;
  height: ${(p) => p.theme.dimensions.vw(4)}px;
`;

const ActionLink = styled.button`
  background: none;
  box-sizing: border-box;
  outline: none;
  width: ${(p) => p.theme.dimensions.vw(6)}px;
  height: ${(p) => p.theme.dimensions.vw(6)}px;
  color: ${(p) => p.theme.textColor};
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;

  > svg {
    width: ${(p) => p.theme.dimensions.vw(6)}px;
    height: ${(p) => p.theme.dimensions.vw(6)}px;
  }
`;

const LBTitle = styled.span`
  grid-row: 3;
  text-align: center;
`;
const LBContact = styled.a`
  font-size: 0.8rem;
  color: #111111;
  grid-row: 1;
  justify-self: end;
  margin-left: 1.5rem;
`;
const LBImage = styled.img`
  width: 70vw;
  height: auto;
  grid-row: 2;
  justify-self: center;
  align-self: center;
  object-fit: contain;
`;
const LBSmallImage = styled.img`
  width: 22vw;
  height: auto;
  grid-row: 2;
  justify-self: center;
  align-self: center;
  object-fit: contain;
`;
const LBWAI = styled.img`
  position: absolute;
  z-index: 50;
  top: -1.5rem;
  left: -1.5rem;
  width: 3rem;
  height: 3rem;
`;

const ContactMeTitle = styled.a`
  font-size: 0.9em;
  justify-self: start;
  text-align: right;
  margin-top: 0.5em;
  color: ${(p) => p.theme.textColor};
  width: 100%;
  grid-column: 2;
`;

const ProductTitle = styled.span`
  font-size: 1em;
  font-weight: bold;
  color: ${(p) => p.theme.textColor};
`;

const StyledBox = styled(Box)`
  grid-column: 1/-1;
  margin: 4px 0px;
  height: 46%;
  font-weight: lighter;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  color: ${(p) => p.theme.textColor};
`;

const ProductDescription = styled(EllipsisText)`
  font-size: 0.8em;
  grid-column: 1/-1;
  font-weight: lighter;
  text-align: start;
  color: ${(p) => p.theme.textColor};
`;
export default ProductsList3;

const ProductContainer = styled.div`
  flex-direction: column;
  display: flex;
  flex: 1;
`;

const ProductImgContainer = styled.div`
  display: flex;
  width: 100%;
`;

const ProductImg = styled.img`
  width: 100%;
  height: 100%;
`;

const ProductImgContainerSmall = styled.div`
  margin-right: 0.2em;
  border: 1px solid black;
  display: flex;
  width: 100%;
  height: 100%;
`;

const ProductPrice = styled.div`
  background-color: #111111;
  color: #f1f1f1;
  align-self: center;
  width: 100%;
  margin-top: 0.4rem;
  justify-self: center;
  padding: 0.4rem 1.6rem;
`;

const GoToProductTitle = styled.div`
  color: ${(p) => p.theme.textColor};;
  font-size: 10px;
  margin-left: 4px;
  font-weight: bold;
  line-height: 14px;
`;

const BadgeImage = styled.div`
  background-image: url(${(p) => p.src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 9.4em;
  height: 2.4em;
`;

const Badge = styled.a`
  outline: none;
  margin-left: -1em;
  cursor: pointer;
`;
